
const getYear = document.getElementsByClassName("getyear");
const getDate = document.getElementById("today-date");

const now = new Date();

getYear[0].textContent = now.getFullYear();
getYear[1].textContent = now.getFullYear();
getDate.textContent = now.toLocaleDateString('en-NZ', { 
  weekday: 'long', 
  day: 'numeric', 
  month: 'long' 
});

// When the user scrolls the page, execute myFunction
window.onscroll = function () {
  myFunction();
};


var header = document.getElementById("edproj-header-container");

var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("edproj-header__sticky");
  } else {
    header.classList.remove("edproj-header__sticky");
  }
}

function detectDevice() {
  var minDesktopWidth = 841;
  return document.documentElement.clientWidth < minDesktopWidth
    ? "mobile"
    : "desktop";
}

// Support button function
window.digitalData = window.digitalData || {
  page: {
    pageInfo: {
      pageID: "interactive",
      pageName: "Support Stuff's Journalism",
      sysEnv: detectDevice(),
      variant: "1",
      version: "1",
      publisher: "",
      articleID: "",
      headline: "",
      author: "",
      source: "",
      lastPublishedTime: "",
    },
    category: {
      pageType: "interactive",
      primaryCategory: "interactive",
    },
    ads: {
      environment: "prod",
      exclusions: "",
      sections: [],
    },
  },
  user: [
    {
      profile: [
        {
          profileInfo: {
            uid: "",
          },
        },
      ],
      segment: {},
    },
  ],
  events: [],
};

function sendEvent(event) {
  if (window.digitalData) {
    window.digitalData.events.push(event);
  }
}
// main.js is bundled as an ES module, so top-level functions stay module-scoped
// unless attached to window explicitly - this is what makes onclick="sendEvent(...)"
// in index.html and the inline <head> scripts able to find it at all.
window.sendEvent = sendEvent;



document.addEventListener('DOMContentLoaded', () => {

    const oneOffButton = document.getElementById('edproj-one-off-button');
    const amountPills = document.querySelectorAll('.edproj-amount-pill');
    const customWrap = document.querySelector('.edproj-amount-custom');
    const customInput = document.querySelector('.edproj-amount-custom__input');

    if (!oneOffButton) return;

    function applyAmount(amount) {
        oneOffButton.setAttribute('data-pp-page', 'checkout');
        oneOffButton.setAttribute('data-pp-amount', amount);
        oneOffButton.setAttribute('data-pp-metadata', `$${amount}-one-off-campaign-page-version-1.1`);
    }

    function applyCustomAmount() {
        const value = customInput.value;
        if (value && Number(value) > 0) {
            applyAmount(value);
        } else {
            // Press Patron renders a broken "$undefined" button when no amount is set,
            // so hold off setting one until the visitor types a valid number.
            oneOffButton.removeAttribute('data-pp-amount');
        }
    }

    amountPills.forEach((pill) => {
        pill.addEventListener('click', () => {
            amountPills.forEach((p) => p.classList.remove('is-active'));
            pill.classList.add('is-active');

            const amount = pill.dataset.amount;

            if (amount === 'other') {
                customWrap.hidden = false;
                customInput.focus();
                applyCustomAmount();
            } else {
                customWrap.hidden = true;
                applyAmount(amount);
            }
        });
    });

    if (customInput) {
        customInput.addEventListener('input', applyCustomAmount);
    }

    oneOffButton.addEventListener('click', (event) => {
        const activePill = document.querySelector('.edproj-amount-pill.is-active');
        if (activePill && activePill.dataset.amount === 'other' && !oneOffButton.getAttribute('data-pp-amount')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            customInput.focus();
        }
    }, true);

});

// Mobile sticky contribute banner: visible only between "scrolled past the
// payment module" and "the repeated CTA button at the bottom is in view",
// so a contribute option is always reachable without ever showing two at once.
document.addEventListener('DOMContentLoaded', () => {

    const stickyBar = document.getElementById('edproj-sticky-cta-bar');
    const paymentModule = document.querySelector('.edproj-side-support');
    const finalCta = document.getElementById('edproj-mobile-cta-button');

    if (!stickyBar || !paymentModule || !finalCta) return;

    function positionStickyBar() {
        stickyBar.style.top = `${header.getBoundingClientRect().height}px`;
    }

    positionStickyBar();
    window.addEventListener('resize', positionStickyBar);

    let pastPaymentModule = false;
    let finalCtaVisible = false;

    function updateStickyBar() {
        stickyBar.classList.toggle('is-visible', pastPaymentModule && !finalCtaVisible);
    }

    const paymentObserver = new IntersectionObserver(([entry]) => {
        // Only count it as "scrolled past" once the module has left the top
        // of the viewport - isIntersecting alone also flips false before the
        // page has scrolled to it at all.
        pastPaymentModule = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateStickyBar();
    }, { threshold: 0 });
    paymentObserver.observe(paymentModule);

    const finalCtaObserver = new IntersectionObserver(([entry]) => {
        finalCtaVisible = entry.isIntersecting;
        updateStickyBar();
    }, { threshold: 0 });
    finalCtaObserver.observe(finalCta);

});